module.exports = __webpack_public_path__ + "img/29f.4f7e32cc.png";